const namespace = 'marketing/campaigns/create';
export default namespace;
